import { useContext, useState } from "react";
import {
  Box,
  Typography,
  Rating,
  TextField,
  Button,
  Drawer,
} from "@mui/material";
import { colors } from "../../style/color/colors";
import { useSessionFeedbackService } from "../../api/apiEndpoints/SessionFeedback";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { AppToast } from "../../commanComponents/AppToast";
import { String } from "../../constants/Strings";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const SessionFeedbackForm = ({ setIsClick }) => {
  const [open, setOpen] = useState(true);
  const [rating, setRating] = useState(4);
  const [feedback, setFeedback] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const { submitFeedback } = useSessionFeedbackService();
  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { userId } = authTokens;

  const handleSubmit = async () => {
    gaCustomEvent(
      String.gaEventName.acrFeedback,
      String.gaEventClickName.acrFeedbackSubmit,
      verifyData.customerId,
    );

    const data = {
      userId: userId,
      rating: rating,
      feedbackMessage: feedback,
    };
    try {
      const response = await submitFeedback(data);

      if (response.httpCode === 200) {
        localStorage.setItem(`${userId}_feedback`, true);
        setSnackbarMessage({
          message: String.FeedbackForm.SaveSuccessMessage,
          severity: String.successSeverity,
        });
        setSnackbarOpen(true);
        setTimeout(() => {
          setSnackbarOpen(false);
          setIsClick(false);
        }, 3000);
      }
    } catch (error) {
      setSnackbarMessage({
        message: String.FeedbackForm.ErrorMessage,
        severity: String.ErrorSeverity,
      });
      setSnackbarOpen(true);
    }
  };
  const handleCloseButton = (state) => {
    setOpen(state);
    setIsClick(false);
  };
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={() => setOpen(false)}
      onClick={() => handleCloseButton(false)}
      PaperProps={{
        sx: {
          borderRadius: "32px 32px 0 0 ",
          p: 3,
          height: "60vh",
        },
      }}
    >
      <Box
        component={"button"}
        variant="outlined"
        sx={{
          width: "50px",
          height: "10px",
          backgroundColor: "#ccc",
          borderRadius: "3px",
          margin: "0 auto 16px",
        }}
        onClick={() => setOpen(false)}
      />
      <Box
        elevation={3}
        style={{
          padding: "20px",
          textAlign: "center",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography
          sx={{
            color: colors.PrimaryWoodSmoke,
            fontSize: "1.5em",
            fontFamily: fonts.manrope,
            fontWeight: "700",
          }}
        >
          {String.FeedbackForm.SessionFeedback}
        </Typography>
        <Typography
          color="textSecondary"
          sx={{
            color: colors.NeutralsMidN200,
            fontSize: 13,
            fontFamily: fonts.manrope,
            fontWeight: "500",
            marginTop: 0,
          }}
        >
          {String.FeedbackForm.shareexperienceBelowText}
        </Typography>

        <Box display="flex" flexDirection="column" alignItems="center" my={2}>
          <Rating
            name="rating"
            value={rating}
            onChange={(event, newValue) => {
              gaCustomEvent(
                String.gaEventName.acrFeedback,
                String.gaEventClickName.acrFeedbackStars,
                verifyData.customerId,
              );
              setRating(newValue);
            }}
            size="large"
            sx={{
              width: "100%",
              marginBottom: "16px",
              fontSize: "3rem",
              display: "flex,",
              justifyContent: "space-evenly",
            }}
          />
          <Typography
            sx={{
              color: colors.ashgrey,
              fontSize: 14,
              fontFamily: fonts.inter,
              fontWeight: rating ? "700" : "400",
            }}
          >
            <span
              style={{
                color: rating ? colors.PrimaryWoodSmoke : colors.ashgrey,
              }}
            >
              {rating}
            </span>
            {String.FeedbackForm.starRatingText}
          </Typography>
        </Box>

        <Typography variant="body2" color="textSecondary" align="left" mt={2}>
          {String.FeedbackForm.additionalFeedbackText}
        </Typography>
        <TextField
          variant="outlined"
          multiline
          rows={3}
          fullWidth
          placeholder={String.FeedbackForm.feedbackPlaceholder}
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          style={{ margin: "8px 0" }}
        />

        <Box sx={{ mt: "30%" }}>
          <Button
            variant="contained"
            onClick={handleSubmit}
            style={{
              width: "80%",
              height: "50px",
              maxWidth: "350px",
              backgroundColor: colors.ColorButtonPrimarysurface,
              color: colors.PrimaryWhite,
              borderRadius: "40px",
              p: "20px",
              mb: "30px",
              lineHeight: "22.2px",
              fontWeight: 700,
              fontSize: "16px",
              textAlign: "center",
              textTransform: "capitalize",
            }}
          >
            {String.FeedbackForm.submitButton}
          </Button>
        </Box>
      </Box>
      <AppToast
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        message={snackbarMessage.message}
        severity={snackbarMessage.severity}
      />
    </Drawer>
  );
};

export default SessionFeedbackForm;
